<div class="container">
  <div class="filters">
    <form [formGroup]="filters">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'admin.partner-management.company-name' | translate }}</mat-label>
        <input matInput formControlName="companyName" maxlength="100">
      </mat-form-field>
      <button mat-flat-button class="blue-flat-button" (click)="clickFilter()">{{'filter' | translate}}</button>
    </form>
  </div>
</div>

<div class="content">
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="demo-table" mat-sort>

    <ng-container matColumnDef="column-id">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin.partner-management.id' | translate }} </th>
      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container>

    <ng-container matColumnDef="column-email">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin.partner-management.email' | translate }} </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <ng-container matColumnDef="column-company-name">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin.partner-management.company-name' | translate }} </th>
      <td mat-cell *matCellDef="let element"> {{element.companyName}} </td>
    </ng-container>

    <ng-container matColumnDef="column-options">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-button class="menuButton" [matMenuTriggerFor]="dropdownMenu" [matMenuTriggerData]="{ partner: element }">
          <mat-icon class="iconMenu">more_vert</mat-icon>
        </button>
      </td>
      <mat-menu #dropdownMenu="matMenu" xPosition="before" yPosition="below">
        <ng-template matMenuContent let-partner="partner">
          <button mat-menu-item (click)="clickChangeTrialPeriod(partner)">
            {{ 'admin.partner-management.options.change-trial-days-option' | translate }}
          </button>
        </ng-template>
      </mat-menu>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        {{ 'none-found' | translate }}
      </td>
    </tr>
  </table>

  <mat-paginator [length]="totalItems"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="pageSizeOptions"
                 (page)="paginationChange($event)"
                 aria-label="Selecionar página">
  </mat-paginator>
</div>

<ng-template #changeTrialPeriodDialog let-data>
  <div class="modal-header">
    <h2 class="modal-title" [innerHTML]="'admin.partner-management.options.change-trial-period' | translate"></h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <br>

  <p class="current-trial-period">
    {{ 'admin.partner-management.options.current-trial-period' | translate }}:
    <strong>{{ data.partner.trialPeriod ?? ('admin.partner-management.period-not-defined' | translate) }}</strong>
  </p>

  <form [formGroup]="trialDaysForm">
  <mat-form-field appearance="outline" class="days-input">
    <mat-label>{{ 'admin.partner-management.options.new-trial-period' | translate }}</mat-label>
    <input
      matInput
      type="number"
      formControlName="trialPeriod"
      min="1"
      max="999"
      (input)="limitTo3Digits($event)"
      cdkFocusInitial>
    <mat-error *ngIf="trialDaysForm.controls['trialPeriod'].hasError('required')">
      {{ 'admin.partner-management.errors.required-trial-period' | translate }}
    </mat-error>
    <mat-error *ngIf="trialDaysForm.controls['trialPeriod'].hasError('min') || trialDaysForm.controls['trialPeriod'].hasError('max')">
      {{ 'admin.partner-management.errors.invalid-trial-period' | translate }}
    </mat-error>
    </mat-form-field>
    <div class="modal-buttons-container">
      <button 
        mat-button 
        class="blue-flat-button" 
        (click)="confirmChangeTrialPeriod(data.partner)"
        [disabled]="trialDaysForm.invalid || changingTrialPeriod">
        {{ 'change' | translate }}
      </button>
      <button mat-button mat-dialog-close>{{ 'cancel' | translate }}</button>
    </div>
  </form>
</ng-template>


